import React from 'react';
import { AuthService } from '../sociallogin';
import { SocialBtn, LabeledSeparator } from '@AydiTeam1/aydi-ui';
import { useTranslations } from 'next-intl';
import { useAnalytics } from '@/modules/shared/hooks/useAnalytics';

type SocialLoginContainerProps = {
  isInvitation?: boolean;
  accountId?: string;
  email?: string;
};

function SocialLoginContainer({ 
  isInvitation = false, 
  accountId,
  email 
}: SocialLoginContainerProps) {
  const t = useTranslations('authentication');
  const { track } = useAnalytics();

  const handleSocialClick = (provider: 'google' | 'apple' | 'facebook', clickHandler: () => void) => {
    if (isInvitation) {
      track('user_clicks_on_social_from_invetion_link', {
        email: email || undefined,
        account_id: accountId,
        provider,
      });
    }
    clickHandler();
  };

  return (
    <>
      <div className='space-y-8'>
        <SocialBtn
          className='w-full'
          text={t('googleSignIn')}
          icon='google'
          onClick={() => handleSocialClick('google', AuthService.loginWithGoogle)}
        />
        <SocialBtn
          className='w-full'
          text={t('appleSignIn')}
          icon='appleBlack'
          onClick={() => handleSocialClick('apple', AuthService.loginWithApple)}
        />
        <SocialBtn
          className='w-full'
          text={t('facebookSignIn')}
          icon='facebookFilled'
          onClick={() => handleSocialClick('facebook', AuthService.loginWithFacebook)}
        />
      </div>
      <LabeledSeparator label={t('or')} />
    </>
  );
}

export default SocialLoginContainer;
